module.exports = __webpack_public_path__ + "static/media/vm_chill_frozen_indufrial.a4afb3a1.png";